import type {
	Account,
	AccountFlags,
	AccountNotificationSettings,
} from 'pkg/api/models/account';
import { age } from 'pkg/api/models/account/fmt';

export function isAnAdult(account: Account): boolean {
	return age(account) >= 18;
}

export function hasFlag(account: Account, flag: AccountFlags): boolean {
	return account.flags.includes(flag);
}

export function hasNotificationSetting(
	account: Account,
	notification: AccountNotificationSettings
): boolean {
	return account.notificationSettings.includes(notification);
}

export function needsParentalConsent(
	account: Account,
	consentAgeThreshold: number = 16
): boolean {
	return age(account) < consentAgeThreshold;
}

export function hasParentalConsent(account: Account): boolean {
	return (
		account.hasOwnProperty('parentalConsentGranted') ||
		account.hasOwnProperty('parentalConsentRevoked')
	);
}
